import React from "react";
import { Provider } from "react-redux";
import { createRoot, Root } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { store } from "../../../../app/store";
import ProductsCategoryDropdown from "../components/ProductsCategoryDropdown";

const roots: Record<string, Root> = {};

export function hydrateProductsCategoryDropdown(rootId: string): void {
  const rootElement = document.getElementById(rootId);
  if (!rootElement || rootElement.dataset.reactInitialized === "true") {
    return;
  }

  try {
    const root = roots[rootId] || createRoot(rootElement);
    if (!roots[rootId]) roots[rootId] = root;

    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <BrowserRouter>
            <ProductsCategoryDropdown />
          </BrowserRouter>
        </Provider>
      </React.StrictMode>
    );

    rootElement.dataset.reactInitialized = "true";
    console.log("ProductsCategoryDropdown component successfully initialized.");
  } catch (error) {
    console.error("Error initializing ProductsCategoryDropdown:", error);
  }
}

declare global {
  interface Window {
    hydrateProductsCategoryDropdown?: (rootId: string) => void;
  }
}

if (typeof window !== "undefined") {
  window.hydrateProductsCategoryDropdown = hydrateProductsCategoryDropdown;
}
